

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


// ALL
import TetraBusAll from "./ot/all/tetra_bus";
import ValidationPriseServiceAll from "./ot/all/prise_service";
import ValidationPriseServiceCoquilleAll from "./ot/all/prise_service_coquille";
import ValidationPoSielSescoAll from "./ot/all/po_siel_sesco";
import ValidationPoSielAdAll from "./ot/all/po_siel_ad";
import ValidationGeolocalisationAll from "./ot/all/geolocalisation";
import ValidationTetraAll from "./ot/all/tetra";
import ValidationPoSielAll from "./ot/all/po_siel";
import ValidationCoquilleConfigDspAll from "./ot/all/coquille_config_dsp";

// CAP JOUR
import TetraBusCapJour from "./ot/cap_jour/tetra_bus";
import ValidationPriseServiceCapJour from "./ot/cap_jour/prise_service";
import ValidationPriseServiceCoquilleCapJour from "./ot/cap_jour/prise_service_coquille";
import ValidationPoSielSescoCapJour from "./ot/cap_jour/po_siel_sesco";
import ValidationPoSielAdCapJour from "./ot/cap_jour/po_siel_ad";
import ValidationGeolocalisationCapJour from "./ot/cap_jour/geolocalisation";
import ValidationTetraCapJour from "./ot/cap_jour/tetra";
import ValidationPoSielCapJour from "./ot/cap_jour/po_siel";
import ValidationCoquilleConfigDspCapJour from "./ot/cap_jour/coquille_config_dsp";

// CAP NOC
import TetraBusCapNoc from "./ot/cap_noc/tetra_bus";
import ValidationPriseServiceCapNoc from "./ot/cap_noc/prise_service";
import ValidationPriseServiceCoquilleCapNoc from "./ot/cap_noc/prise_service_coquille";
import ValidationPoSielSescoCapNoc from "./ot/cap_noc/po_siel_sesco";
import ValidationPoSielAdCapNoc from "./ot/cap_noc/po_siel_ad";
import ValidationGeolocalisationCapNoc from "./ot/cap_noc/geolocalisation";
import ValidationTetraCapNoc from "./ot/cap_noc/tetra";
import ValidationPoSielCapNoc from "./ot/cap_noc/po_siel";
import ValidationCoquilleConfigDspCapNoc from "./ot/cap_noc/coquille_config_dsp";

// KEOLIS
import TetraBusKeolis from "./ot/keolis/tetra_bus";
import ValidationPriseServiceKeolis from "./ot/keolis/prise_service";
import ValidationPriseServiceCoquilleKeolis from "./ot/keolis/prise_service_coquille";
import ValidationPoSielSescoKeolis from "./ot/keolis/po_siel_sesco";
import ValidationPoSielAdKeolis from "./ot/keolis/po_siel_ad";
import ValidationGeolocalisationKeolis from "./ot/keolis/geolocalisation";
import ValidationTetraKeolis from "./ot/keolis/tetra";
import ValidationPoSielKeolis from "./ot/keolis/po_siel";
import ValidationCoquilleConfigDspKeolis from "./ot/keolis/coquille_config_dsp";

// CDS
import TetraBusCds from "./ot/cds/tetra_bus";
import ValidationPriseServiceCds from "./ot/cds/prise_service";
import ValidationPriseServiceCoquilleCds from "./ot/cds/prise_service_coquille";
import ValidationPoSielSescoCds from "./ot/cds/po_siel_sesco";
import ValidationPoSielAdCds from "./ot/cds/po_siel_ad";
import ValidationGeolocalisationCds from "./ot/cds/geolocalisation";
import ValidationTetraCds from "./ot/cds/tetra";
import ValidationPoSielCds from "./ot/cds/po_siel";
import ValidationCoquilleConfigDspCds from "./ot/cds/coquille_config_dsp";

import PierreCap from "./pierre/pierrecap";
import PierreKeolis from "./pierre/pierrekeolis";
import HomePage from "./pierre/main_page";

import Home from "./home";



import AccueilButton from "./components/accueil_button";


function Main() {
  return (
    <Router>

      <Routes>
        <Route path="/a87f2430f2" element={<Home />} />

        // ALL
        <Route path="/0f2f796d1947/all/tetra_bus" element={<TetraBusAll />} />
        <Route path="/0f2f796d1947/all/po_siel" element={<ValidationPoSielAll />} />
        <Route path="/0f2f796d1947/all/prise_service" element={<ValidationPriseServiceAll />} />
        <Route path="/0f2f796d1947/all/po_siel_sesco" element={<ValidationPoSielSescoAll />} />
        <Route path="/0f2f796d1947/all/po_siel_ad" element={<ValidationPoSielAdAll />} />
        <Route path="/0f2f796d1947/all/prise_service_coquille" element={<ValidationPriseServiceCoquilleAll />} />
        <Route path="/0f2f796d1947/all/geolocalisation" element={<ValidationGeolocalisationAll />} />
        <Route path="/0f2f796d1947/all/tetra" element={<ValidationTetraAll />} />
        <Route path="/0f2f796d1947/all/coquille_config_dsp" element={<ValidationCoquilleConfigDspAll />} />

        // CAP JOUR 7b0cc0d68f230f2f796d1947e4f15d18721c4314d3f377596207f2409746c1a8
        <Route path="/7b0cc0d68f23/cap_jour/tetra_bus" element={<TetraBusCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/po_siel" element={<ValidationPoSielCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/prise_service" element={<ValidationPriseServiceCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/po_siel_sesco" element={<ValidationPoSielSescoCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/po_siel_ad" element={<ValidationPoSielAdCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/prise_service_coquille" element={<ValidationPriseServiceCoquilleCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/geolocalisation" element={<ValidationGeolocalisationCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/tetra" element={<ValidationTetraCapJour />} />
        <Route path="/7b0cc0d68f23/cap_jour/coquille_config_dsp" element={<ValidationCoquilleConfigDspCapJour />} />

        // CAP NOC
        <Route path="/7b0cc0d68f23/cap_noc/tetra_bus" element={<TetraBusCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/po_siel" element={<ValidationPoSielCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/prise_service" element={<ValidationPriseServiceCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/po_siel_sesco" element={<ValidationPoSielSescoCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/po_siel_ad" element={<ValidationPoSielAdCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/prise_service_coquille" element={<ValidationPriseServiceCoquilleCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/geolocalisation" element={<ValidationGeolocalisationCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/tetra" element={<ValidationTetraCapNoc />} />
        <Route path="/7b0cc0d68f23/cap_noc/coquille_config_dsp" element={<ValidationCoquilleConfigDspCapNoc />} />

        // KEOLIS
        <Route path="/f2409746c1a8/keolis/tetra_bus" element={<TetraBusKeolis />} />
        <Route path="/f2409746c1a8/keolis/po_siel" element={<ValidationPoSielKeolis />} />
        <Route path="/f2409746c1a8/keolis/prise_service" element={<ValidationPriseServiceKeolis />} />
        <Route path="/f2409746c1a8/keolis/po_siel_sesco" element={<ValidationPoSielSescoKeolis />} />
        <Route path="/f2409746c1a8/keolis/po_siel_ad" element={<ValidationPoSielAdKeolis />} />
        <Route path="/f2409746c1a8/keolis/prise_service_coquille" element={<ValidationPriseServiceCoquilleKeolis />} />
        <Route path="/f2409746c1a8/keolis/geolocalisation" element={<ValidationGeolocalisationKeolis />} />
        <Route path="/f2409746c1a8/keolis/tetra" element={<ValidationTetraKeolis />} />
        <Route path="/f2409746c1a8/keolis/coquille_config_dsp" element={<ValidationCoquilleConfigDspKeolis />} />

        // CDS
        <Route path="/4d3f3775962/cds/tetra_bus" element={<TetraBusCds />} />
        <Route path="/4d3f3775962/cds/po_siel" element={<ValidationPoSielCds />} />
        <Route path="/4d3f3775962/cds/prise_service" element={<ValidationPriseServiceCds/>} />
        <Route path="/4d3f3775962/cds/po_siel_sesco" element={<ValidationPoSielSescoCds />} />
        <Route path="/4d3f3775962/cds/po_siel_ad" element={<ValidationPoSielAdCds />} />
        <Route path="/4d3f3775962/cds/prise_service_coquille" element={<ValidationPriseServiceCoquilleCds />} />
        <Route path="/4d3f3775962/cds/geolocalisation" element={<ValidationGeolocalisationCds />} />
        <Route path="/4d3f3775962/cds/tetra" element={<ValidationTetraCds />} />
        <Route path="/4d3f3775962/cds/coquille_config_dsp" element={<ValidationCoquilleConfigDspAll />} />

        <Route path="/declarations_pb" element={<HomePage />} />
        <Route path="/7b0cc0d68f23/declarations_pb_cap" element={<PierreCap />} />
        <Route path="/f2409746c1a8/declarations_pb_keolis" element={<PierreKeolis />} />

      </Routes>
    </Router>
  );
}

export default Main;
